/* src/app/pages/small-molecule/graph-dialog/graph-dialog.component.scss */
.chartCards {
  background-color: lightgoldenrodyellow;
}
/*# sourceMappingURL=graph-dialog.component.css.map */
